module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-3-b32aeb0ee0261032bf5fa26561a4c206.jpg";